import React, { useEffect, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import dimensions from "../../../../../util/dimensions-util";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import UTIL from '../../../../../util';

// Icons
import newIcon from "../../../../../assets/images/Fireboard/new.png";
import voucherGreen from '../../../../../assets/images/Fireboard/vouchers/voucherGreen.png';
import voucherRed from '../../../../../assets/images/Fireboard/vouchers/voucherRed.png';
import voucherWhite from '../../../../../assets/images/Fireboard/vouchers/voucherWhite.png';

import classes from "./ChecksList.module.css";
import classNames from "classnames";
import SearchBox from "../../SearchBox";
import CalendarFilter from "../../CalendarFilter";
import extraButton from "../../../../../assets/images/Fireboard/action.png";
import payNowPound from "../../../../../assets/images/Fireboard/payNowPound.png";
import marketOrder from "../../../../../assets/images/Fireboard/marketOrder.png";
import TablesList from "../TablesList";
import FireboardUtils from "../../../../../util/fireboard-util";
import Button from "../../../../../components/Button";

const { vw: widthConstant } = dimensions;

const CountersArray = [
    { id: 0, name: 'Total', key: 'total' },
    { id: 1, name: 'Open', key: 'open' },
    { id: 2, name: 'Closed', key: 'closed' },
    { id: 3, name: 'Paid', key: 'paid' },
    { id: 4, name: 'Partial', key: 'partial' },
    { id: 5, name: 'Unpaid', key: 'unpaid' },
    { id: 6, name: 'Pre Auth', key: 'preAuth' },
    { id: 7, name: 'Unposted', key: 'unposted' },
];

const dueTimeComparator = (time1, time2, nodeA, nodeB) => {
    if (nodeA.data.dueTimeForSorting === null && nodeB.data.dueTimeForSorting === null)
        return 0;
    if (nodeA.data.dueTimeForSorting === null)
        return -1;
    if (nodeB.data.dueTimeForSorting === null)
        return 1;
    return nodeA.data.dueTimeForSorting - nodeB.data.dueTimeForSorting;
};

const checkInTimeComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
    if (nodeA.data.checkInTimeForSorting === null && nodeB.data.checkInTimeForSorting === null)
        return 0;
    if (nodeA.data.checkInTimeForSorting === null)
        return - 1;
    if (nodeB.data.checkInTimeForSorting === null)
        return 1;
    return nodeA.data.checkInTimeForSorting - nodeB.data.checkInTimeForSorting;
};

const stringSortComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
    if (valueA == valueB) return 0;
    return (valueA > valueB) ? 1 : -1;
};

const timeSortComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
    return nodeA.data.ellapsedTimeForSorting - nodeB.data.ellapsedTimeForSorting;
};

const checkNumberSortComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
    if (nodeA.data.checkNumberForSorting === nodeB.data.checkNumberForSorting) return 0;
    return (nodeA.data.checkNumberForSorting > nodeB.data.checkNumberForSorting) ? 1 : -1;
};

const paidAmountComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
    return nodeA.data.paidAmount - nodeB.data.paidAmount;
};

let gridAPI;

const ChecksList = ({

    checksRowData = [],
    setSelectedCheck = () => { },
    selectedItem = {},
    showSearchBox,
    value,
    onSearchReset,
    handleChange,
    searchChecks,
    selectedDate,
    onDateChange,
    onlineOrderAdvanceLimit,
    resetFilterCalendar,
    isFutureOrderType,
    managerMode,
    activeMgrFilter,
    currency = '$',
    currentView,
    sortModel,
    updateSortModel,
    showVoucherChecks,
    pagination,
    checkFilters,
    sensorsMap,
    fbVenueMode,
    counters,
    setCounters,
}) => {
    const [checksCount, setChecksCount] = useState({
        total: 0,
        open: 0,
        closed: 0,
        paid: 0,
        partial: 0,
        unpaid: 0,
        preAuth: 0,
        unposted: 0,
    });
    useEffect(() => {
        const checks = getChecksFiltered();
        const openedChecksCount = checks.filter(check => check.open).length;
        const closedChecksCount = checks.filter(check => !check.open).length;
        const paidChecksCount = checks.filter(check => check.unpaidAmount === 0 && check.paidAmount > 0).length;
        const partialPaidChecksCount = checks.filter(check => check.unpaidAmount !== 0 && check.paidAmount > 0).length;
        const unpaidChecksCount = checks.length - (paidChecksCount + partialPaidChecksCount);
        const preAuthfilterFn = check => check.unpaidAmount > 0 && check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0);
        const preAuthChecksCount = checks.filter(preAuthfilterFn).length;
        const unpostedFilterFn = check => check.sourceType !== 3 && check.tickets && check.tickets.some(tkt => tkt.enableRepostPos);
        const unpostedCount = checks.filter(unpostedFilterFn).length;

        setChecksCount({
            total: checks.length,
            open: openedChecksCount,
            closed: closedChecksCount,
            paid: paidChecksCount,
            partial: partialPaidChecksCount,
            unpaid: unpaidChecksCount,
            preAuth: preAuthChecksCount,
            unposted: unpostedCount,
        });
    }, [checksRowData]);

    useEffect(() => {
        if (!!gridAPI) {
            if (selectedItem?.rowIndex >= 0)
                gridAPI.ensureIndexVisible(selectedItem.rowIndex, null);
            const columns = [
                'icon',
                'status',
                'checkNumber',
                'ellapsedTime',
                'dueTime',
                'checkInTime',
                'deliverTo',
                'paid',
                'extraActions',
            ];
            gridAPI.redrawRows({ columns: columns });
        }
    }, [checksRowData, managerMode]);

    useEffect(() => {
        if (!!gridAPI) {
            if (selectedItem?.rowIndex >= 0)
                gridAPI.ensureIndexVisible(selectedItem.rowIndex, null);
        }
    }, [selectedItem]);

    const getChecksFiltered = () => {
        if (managerMode) {
            let filterFunction = () => true;
            switch (activeMgrFilter) {
                case 'pre-auth': {
                    filterFunction = check => check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0 && check.unpaidAmount > 0);
                    break;
                }
                case 'over-serve': {
                    filterFunction = check => {
                        return check.relatedNotifications.some(n => n.notificationTypeId === 15 && n.data.checkHeaderId === check.id);
                    };
                    break;
                }
                case 'id-check': {
                    filterFunction = check => {
                        return check.relatedNotifications.some(n => n.notificationTypeId === 14 && n.data.checkHeaderId === check.id);
                    };
                    break;
                }
                default: {
                    filterFunction = () => true;
                    break;
                }
            }
            return checksRowData && checksRowData.filter(filterFunction);
        }
        return checksRowData;
    };

    const filterChecksUsingCounters = checks => {
        if (counters.size === 0 || counters.has('total')) {
            return checks;
        }
        let checksArray = [];
        checks.forEach(check => {
            const isPreAuth = Array.isArray(check.tickets)
                ? check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0)
                : false;
            const enableRepostPos = Array.isArray(check.tickets)
                ? check.tickets.some(tkt => tkt.enableRepostPos)
                : false;
            if ((counters.has('open') && check.open) ||
                (counters.has('closed') && !check.open) ||
                (counters.has('paid') && check.unpaidAmount === 0 && check.paidAmount > 0) ||
                (counters.has('partial') && check.unpaidAmount !== 0 && check.paidAmount > 0) ||
                (counters.has('unpaid') && check.paidAmount === 0) ||
                (counters.has('preAuth') && check.unpaidAmount > 0 && isPreAuth) ||
                (counters.has('unposted') && check.sourceType !== 3 && enableRepostPos)
            ) {
                checksArray.push(check);
            }
        });
        return Array.from(new Map(checksArray.map(c => [c.id, c])).values()); //remove duplicates
    };

    const PhoneAndCheckNumber = ({
        phoneNumber = "",
        checkNumber = "",
        rowSelected,
        highlightRow,
    }) => {
        const cellStyle = classNames({
            [classes.phoneAndCheckContainer]: true,
            [classes.selectedRow]: rowSelected,
            [classes.highlightRow]: highlightRow,
        });
        return (
            <div className={cellStyle}>
                <div
                    className={classNames(
                        `${classes.cellText}`,
                        `${classes.phoneNumberStyle}`
                    )}
                >
                    {phoneNumber}
                </div>
                <div className={classes.cellText}>
                    {checkNumber && checkNumber.length > 13
                        ? `${checkNumber.substring(0, 11)}${checkNumber.substring(checkNumber.length - 1)}`
                        : checkNumber}
                </div>
            </div>
        );
    };

    const Status = ({ status, color, isNew, rowSelected, highlightRow }) => {
        const cellStyle = classNames({
            [classes.statusContainer]: !isNew,
            [classes.statusNewContainer]: isNew,
            [classes.selectedRow]: rowSelected,
            [classes.highlightRow]: highlightRow,
        });
        return (
            <div className={cellStyle}>
                <span className={classes.paidCellText} style={{ color }}>
                    {status}
                </span>
                {isNew && (
                    <img
                        src={newIcon}
                        className={classNames(`${classes.iconSize}`, `${classes.newIcon}`)}
                        alt="new"
                    />
                )}
            </div>
        );
    };

    const PaidStatus = ({ paid, rowSelected, highlightRow, paidAmount, unpaidAmount, paidAmountChanged }) => {
        const cellStyle = classNames({
            [classes.centerWithPadding]: true,
            [classes.circle]: paid === 'partial',
            [classes.selectedRow]: rowSelected,
            [classes.highlightRow]: highlightRow,
            [classes.updatedRow]: paidAmountChanged,
        });
        return (
            <div className={cellStyle}>
                <img
                    src={paid}
                    className={classes.iconSize}
                    alt="paid"
                />
            </div>
        );
    };

    const getOverlayContentTemplate = () => {
        return `<span class="ag-overlay-loading-center">Please wait while checks are loading</span>`;
    };

    const getOverlayNoRowsTemplate = () => {
        return `<span class="ag-overlay-loading-center">No checks available</span>`;
    };

    const cellStyles = { border: 'none', padding: '0px' };

    const columnDefs = [
        {
            headerName: "Mode",
            field: "icon",
            cellRendererFramework: Mode,
            cellRendererParams: { managerMode: managerMode, currency: currency, fbVenueMode },
            resizable: false,
            width: (fbVenueMode ? 100 : 70) * widthConstant,
            flex: 1,
            cellStyle: cellStyles,
        },
        {
            headerName: "Status",
            field: "status",
            width: 140 * widthConstant,
            flex: 1,
            resizable: false,
            sortable: true,
            comparator: stringSortComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({
                data: { status = "", color = "", isNew = false, rowSelected = false, relatedNotifications, highlightRow = false },
            }) => {
                const cellStyle = rowSelected
                    ? classes.centerWithSelected
                    : classes.centerWithPadding;
                const hasIdCheckNotification =
                    relatedNotifications && relatedNotifications.filter(n => n.notificationTypeId === 14);
                return (
                    <div className={highlightRow ? [cellStyle, classes.highlightRow] : cellStyle}>
                        {managerMode ? (
                            hasIdCheckNotification && hasIdCheckNotification.length > 0 ? (
                                <span className={classes.overServeText}>
                                    ID CHECK
                                </span>
                            ) : null
                        ) : (
                            <Status
                                status={status}
                                color={color}
                                isNew={isNew}
                                rowSelected={rowSelected}
                                highlightRow={highlightRow}
                            />
                        )}
                    </div>
                );
            },
        },
        {
            headerName: "Number",
            field: "checkNumber",
            width: 130 * widthConstant,
            resizable: false,
            flex: 1,
            sortable: true,
            comparator: checkNumberSortComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({
                data: { checkNumber = "", phoneNumber = "", rowSelected = false, highlightRow = false },
            }) => {
                return (
                    <PhoneAndCheckNumber
                        phoneNumber={phoneNumber}
                        checkNumber={checkNumber}
                        rowSelected={rowSelected}
                        highlightRow={highlightRow}
                    />
                );
            },
        },
        {
            headerName: "Time",
            field: "ellapsedTime",
            width: 80 * widthConstant,
            resizable: false,
            flex: 1,
            sortable: true,
            comparator: timeSortComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({ data: { ellapsedTime, ellapsedTimeColor, rowSelected, highlightRow } }) => {
                var btnClass = classNames({
                    [classes.column]: true,
                    [classes.selectedRow]: rowSelected,
                    [classes.highlightRow]: highlightRow,
                });
                return <div className={btnClass} style={{ color: ellapsedTimeColor }}>{ellapsedTime}</div>;
            },
        },
        {
            headerName: "Due",
            field: "dueTime",
            width: 110 * widthConstant,
            resizable: false,
            flex: 1,
            sortable: true,
            cellStyle: cellStyles,
            comparator: dueTimeComparator,
            cellRendererFramework: ({ data: { dueTime, rowSelected, highlightRow } }) => {
                var cellStyle = classNames({
                    [classes.column]: true,
                    [classes.selectedRow]: rowSelected,
                    [classes.highlightRow]: highlightRow,
                });
                return <div className={cellStyle}>{dueTime}</div>;
            },
        },
        {
            headerName: "Check In",
            field: "checkInTime",
            width: 150 * widthConstant,
            resizable: false,
            flex: 1,
            sortable: true,
            comparator: checkInTimeComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({ data: { checkInTime, rowSelected, highlightRow } }) => {
                const cellStyle = classNames({
                    [classes.column]: true,
                    [classes.selectedRow]: rowSelected,
                    [classes.highlightRow]: highlightRow,
                });
                return <div className={cellStyle}>{checkInTime}</div>;
            },
        },
        {
            headerName: "Deliver To",
            field: "deliverTo",
            width: 130 * widthConstant,
            resizable: false,
            flex: 1,
            sortable: true,
            comparator: stringSortComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({ data: { deliverTo, slotName, rowSelected, highlightRow, deliverToChanged = false } }) => {
                const cellStyle = classNames({
                    [classes.column]: true,
                    [classes.selectedRow]: rowSelected,
                    [classes.highlightRow]: highlightRow,
                    [classes.updatedRow]: deliverToChanged,
                    [classes.scrollView]: true,
                });
                const deliverToAndSlotName = slotName ? `${deliverTo}\n[${slotName}]` : deliverTo;
                return <div className={cellStyle}>{deliverToAndSlotName}</div>;
            },
        },
        {
            headerName: "Paid",
            field: "paid",
            resizable: false,
            width: 60 * widthConstant,
            flex: 1,
            sortable: true,
            comparator: paidAmountComparator,
            cellStyle: cellStyles,
            cellRendererFramework: ({ data: { paid, rowSelected, highlightRow = false, unpaidAmount, paidAmount, paidAmountChanged = false } }) => {
                return <PaidStatus
                    paid={paid}
                    unpaidAmount={unpaidAmount}
                    paidAmount={paidAmount}
                    rowSelected={rowSelected}
                    highlightRow={highlightRow}
                    paidAmountChanged={paidAmountChanged}
                />;
            },
        },
        {
            headerName: "",
            field: "extraActions",
            resizable: false,
            width: 60 * widthConstant,
            flex: 1,
            cellStyle: cellStyles,
            cellRendererFramework: ({
                data: { onHandleCheckActions, rowSelected, highlightRow },
            }) => {
                const cellStyle = classNames({
                    [classes.centerWithPadding]: true,
                    [classes.selectedRow]: rowSelected,
                    [classes.highlightRow]: highlightRow,
                });
                return (
                    <div className={cellStyle} onClick={onHandleCheckActions}>
                        <img src={extraButton} className={classes.iconSize} alt="" />
                    </div>
                );
            },
        },
    ];

    const onGridReady = params => {
        gridAPI = params.api;
        params.api.sizeColumnsToFit();
        if (sortModel && sortModel?.colId && sortModel?.sort) {
            //sortModel object - sortModel = { colId: 'colId', sort: 'asc | desc | null' };
            gridAPI && gridAPI.setSortModel([sortModel]);
        }
    }

    const onGridSizeChanged = (params) => {
        params.api.sizeColumnsToFit();
    }

    const onFirstDataRendered = params => {
        params.api.sizeColumnsToFit();
    };

    const alteredColumns = () => {
        let columnsToDisplay = columnDefs;
        return columnsToDisplay;
    };

    const onRowClicked = (data, rowIndex) => {
        setSelectedCheck({ ...data, rowIndex });
    }

    const heightConstant = UTIL.round(window.innerHeight / 900);

    const getGridHeight = () => {
        if (showVoucherChecks) {
            if (showSearchBox && selectedDate && isFutureOrderType) return '64vh';
            else if (showSearchBox) return '72vh';
            else if (selectedDate && isFutureOrderType) return '72vh';
            else return '78vh';
        } else {
            if (showSearchBox && selectedDate && isFutureOrderType) return '75vh';
            else if (showSearchBox) return '81vh';
            else if (selectedDate && isFutureOrderType) return '82vh';
            else return '88vh';
        }
    };

    const onSortChanged = params => {
        const sortModel = params.api.getSortModel();
        if (sortModel && sortModel.length) {
            updateSortModel && updateSortModel(sortModel[0]);
        } else {
            updateSortModel && updateSortModel({ colId: '', sort: '' });
        }
    };

    const onClickCounter = counter => {
        const copiedCounters = new Map(counters);
        if (copiedCounters.has(counter.key)) {
            copiedCounters.delete(counter.key);
        } else {
            copiedCounters.set(counter.key, true);
        }
        setCounters(copiedCounters);
    };

    return (
        <div className={classes.checks}>
            {showSearchBox ? (
                <SearchBox
                    value={value}
                    onSearchReset={onSearchReset}
                    handleChange={handleChange}
                    searchChecks={searchChecks}
                />
            ) : null}
            {selectedDate && isFutureOrderType ? (
                <CalendarFilter
                    selectedDate={selectedDate}
                    onDateChange={onDateChange}
                    onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
                    resetFilterCalendar={resetFilterCalendar}
                />
            ) : null}
            <div className={classes.checkCountsWrapper}>
                {CountersArray.map(counter =>
                    <Button
                        key={`id-${counter.id}`}
                        className={classNames({ [classes.checkCountBtnSelected]: counters.has(counter.key), [classes.checkCountBtnUnselected]: !counters.has(counter.key) })}
                        onClick={() => onClickCounter(counter)}>
                        <div className={classNames({ [classes.checkCountTxtSelected]: counters.has(counter.key), [classes.checkCountTxtUnselected]: !counters.has(counter.key) })}>
                            {counter.name.toUpperCase()}: {checksCount[counter.key]}
                        </div>
                    </Button>
                )}
            </div>
            <div
                style={{ height: getGridHeight() }}
                className={classNames({
                    [classes.defaultContainerStyle]: true,
                    [classes.futureOrdersContainerStyle]: isFutureOrderType && checksRowData.length,
                })}
            >
                {currentView === 'list' ?
                    <div className={`ag-theme-alpine-dark`} style={{ height: '100%', width: '100%' }}>
                        <AgGridReact
                            suppressRowTransform={true}
                            key={pagination ? 'grid-with-pagination' : 'grid-without-pagination'}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            columnDefs={alteredColumns()}
                            rowData={filterChecksUsingCounters(getChecksFiltered())}
                            rowClass={[classes.gridRowClass]}
                            rowHeight={70 * heightConstant}
                            headerHeight={80 * heightConstant}
                            modules={[ClientSideRowModelModule]}
                            onRowClicked={({ data, rowIndex }) => onRowClicked(data, rowIndex)}
                            overlayNoRowsTemplate={getOverlayNoRowsTemplate()}
                            overlayLoadingTemplate={getOverlayContentTemplate()}
                            deltaRowDataMode={true}
                            getRowNodeId={data => data.id}
                            onSortChanged={onSortChanged}
                            pagination={pagination}
                            paginationPageSize={10}
                        />
                    </div>
                    :
                    <TablesList
                        checks={filterChecksUsingCounters(getChecksFiltered())}
                        selectedCheck={selectedItem}
                        onSelectCheck={onRowClicked}
                        checkFilters={checkFilters}
                        sensorsMap={sensorsMap}
                        managerMode={managerMode}
                        currency={currency}
                        fbVenueMode={fbVenueMode}
                    />
                }
            </div>
        </div>
    );
};

export default ChecksList;

class Mode extends React.Component {
    render() {
        const { data, managerMode, currency, fbVenueMode } = this.props;
        const { sourceType, rowSelected, relatedNotifications, highlightRow = false, orders, vouchers, storeName, tab } = data || {};
        const cellStyle = rowSelected ? classes.centerWithSelected : classes.centerWithPadding;
        // const hasOverServerNotification = relatedNotifications && relatedNotifications.filter(n => n.notificationTypeId === 15);
        let delivery = false;
        let isMarketPlaceOrder = false;
        let isCatering = false;
        let imgSrc;
        if (orders && orders.length > 0) {
            delivery = orders[0].delivery || false;
            isMarketPlaceOrder = orders[0].marketplace || false;
            isCatering = orders[0].catering || false;
        }
        imgSrc = FireboardUtils.getCheckSourceIcon(sourceType, delivery, isMarketPlaceOrder, isCatering, tab);
        if (currency === '£' && sourceType === 9) {
            imgSrc = payNowPound;
        }

        const isVoucherAvailable = (Array.isArray(vouchers) && vouchers.length > 0);
        const voucherStatus = isVoucherAvailable ? vouchers[0].status : null;
        let voucherIcon = voucherStatus === 5 ? voucherGreen : voucherStatus === 0 ? voucherWhite : voucherRed;

        const getIconStyle = () => {
            let iconStyle;
            if (fbVenueMode)
                iconStyle = classes.iconSizeWithVenue;
            else
                iconStyle = (isMarketPlaceOrder && !delivery) ? classes.marketOrder : classes.iconSize;
            return iconStyle;
        };

        const order0 = (orders && orders.length > 0) ? orders[0] : {};

        const vendorName = order0?.marketplace
            ? order0?.marketplaceVendorName
                ? order0?.marketplaceVendorName
                : ''
            : order0?.deliveryVendorName
                ? order0?.deliveryVendorName
                : '';

        const vendorOrderId = order0?.marketplace
            ? order0?.marketplaceOrderId
                ? order0?.marketplaceOrderId
                : ''
            : order0?.deliveryVendorOrderId
                ? order0?.deliveryVendorOrderId
                : '';

        const isOneDineIntVendor = vendorName === 'OneDineInt';

        const showVendorName = (order0 && !isOneDineIntVendor && Object.keys(order0).length > 0) ? true : false;

        return (
            <div className={cellStyle}>
                {isVoucherAvailable ? (
                    <img
                        src={voucherIcon}
                        className={classes.voucherIconSize}
                        alt="voucher"
                    />
                ) : (
                    managerMode ?
                        // (
                        //   hasOverServerNotification && hasOverServerNotification.length > 0 ? (
                        //     <span className={classes.overServeText}>
                        //       OVER SERVE
                        //     </span>
                        //   ) : 
                        null
                        // ) 
                        : (
                            <div className={classes.modeWrapper}>
                                {fbVenueMode && (
                                    <div className={classes.storeNameWrapper}>
                                        <span className={classes.storeNameTxt}>
                                            {storeName}
                                        </span>
                                    </div>
                                )}
                                {fbVenueMode && (
                                    <img
                                        src={imgSrc}
                                        className={getIconStyle()}
                                        alt="mode"
                                    />
                                )}
                                {!(fbVenueMode) && (
                                    <img
                                        src={imgSrc}
                                        className={getIconStyle()}
                                        alt="mode"
                                    />
                                )}
                                {showVendorName && (
                                    <div className={classes.storeNameTxt}>{vendorName}</div>
                                )}
                            </div>
                        )
                )}
            </div>
        );
    };
};
